<template>
  <div class="bg-header-back text-white h-16">
    <div class="page-container">
      <div class="relative space-x-4 flex h-16 items-center justify-between ml-4 lg:ml-0">
        <a :href="returnUrl"> &leftarrow; {{ $t("Back to") }} {{ brandconfig.BRAND_TITLE }} </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import brandconfig from "@/brandconfig";
import { computed } from "vue";

const returnUrl = computed(() => {
  return localStorage.returnUrl ?? brandconfig.WEBSITE;
});
</script>
